"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.combinePath = void 0;
/**
 * Combines strings into a path.
 * @return {string} The combined paths.
 */
var combinePath = function () {
    var paths = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        paths[_i] = arguments[_i];
    }
    var separator = "/";
    var replace = new RegExp(separator + "{1,}", "g");
    return paths
        .filter(function (x) { return x; })
        .join(separator)
        .replace(replace, separator);
};
exports.combinePath = combinePath;
//# sourceMappingURL=path-helper.js.map